import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-brand-teal/5 border-2 border-brand-teal/20 p-8 md:p-12 rounded-3xl text-center relative overflow-hidden" data-id="element-47">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-teal/5 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none" data-id="element-48"></div>

          <div className="w-20 h-20 bg-brand-teal/10 rounded-full flex items-center justify-center mx-auto mb-8 relative z-10" data-id="element-49">
            <ShieldCheck className="w-10 h-10 text-brand-teal" data-id="element-50" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-brand-navy mb-6 relative z-10" data-id="element-51">
            Garantía Total de "Paz en Casa" por 7 Días
          </h2>

          <p className="text-lg md:text-xl text-brand-navy/80 leading-relaxed mb-0 relative z-10 font-serif" data-id="element-52">
            Si aplicas el protocolo por una semana y no ves una reducción en los
            berrinches o una mejora en su atención,{' '}
            <strong className="text-brand-teal font-bold" data-id="element-53">
              te devuelvo el 100% de tu dinero
            </strong>
            . Sin preguntas. Me quedo con el riesgo yo.
          </p>
        </motion.div>
      </div>
    </section>;
}